import { UseCountdown } from "./UseCountdown";

const OfferCountdown = () => {
  const { hours, minutes, seconds } = UseCountdown();

  const isCompleted = hours <= 0 && minutes <= 0 && seconds <= 0;

  if (isCompleted) {
    return <span style={{ fontWeight: 600 }}>Hurry Up!</span>;
  } else {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontFamily: "Inter, sans-serif",
        }}
      >
        <span
          style={{
            color: "#333",
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          Offer ends in :
        </span>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#111",
            color: "#fff",
            borderRadius: "10px",
            padding: "8px 15px",
            fontSize: "16px",
            fontWeight: 600,
            letterSpacing: "1px",
          }}
        >
          <span>{hours.toString().padStart(2, "0")}</span>
          <span style={{ margin: "0 6px", fontWeight: 500 }}>:</span>
          <span>{minutes.toString().padStart(2, "0")}</span>
          <span style={{ margin: "0 6px", fontWeight: 500 }}>:</span>
          <span>{seconds.toString().padStart(2, "0")}</span>
        </div>
      </div>
    );
  }
};

export default OfferCountdown;
